// src/components/shared/VideoPlayer.tsx
// Minimal video player with download. Uses native HTML5 <video> with optional poster.

import { Download } from 'lucide-react';

interface Props {
  src: string;
  poster?: string | null;
  className?: string;
}

export function VideoPlayer({ src, poster, className = '' }: Props) {
  return (
    <div className={`rounded-xl overflow-hidden bg-black/30 border border-white/10 ${className}`}>
      <video
        controls
        preload="metadata"
        poster={poster || undefined}
        className="w-full max-h-[480px] object-contain"
        src={src}
      >
        Tu navegador no soporta video.
      </video>
      <div className="flex justify-end p-2 bg-white/5">
        <a
          href={src}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-lg text-white/50 hover:text-white/90 hover:bg-white/10 transition-colors"
        >
          <Download size={12} /> Descargar
        </a>
      </div>
    </div>
  );
}
